import apple from "./apple.svg"
import google from "./google.svg"
import logo from "./logos/logo.svg"
import logoWithText from "./logos/logoWithText.svg"
import aol from "./toAol.svg"
import gmx from "./toGMX.svg"
import gmail from "./toGmail.svg"
import hey from "./toHey.svg"
import icloud from "./toICloud.svg"
import outlook from "./toOutlook.svg"
import protonmail from "./toProtonmail.svg"
import yahoo from "./toYahoo.svg"
import yandex from "./toYandex.svg"
import zoho from "./toZoho.svg"

const Images = {
  logo,
  logoWithText,

  google,
  apple,

  gmail,
  outlook,
  yahoo,
  protonmail,
  aol,
  zoho,
  icloud,
  gmx,
  hey,
  yandex
}

export default Images
